export const RELATION_SHIP_ID = '{B3F7F3EC-E6F8-4C02-96A0-866CE7FA2607}';

export const ACTION = '/catalog/GetAssociatedProducts';
